

























import {
  Vue, Component, Prop, PropSync,
} from 'vue-property-decorator';

@Component({})
export default class OnboardingInfo extends Vue {
  @PropSync('onboardCount', {}) onboardCountSync!: any;

  @PropSync('selectedDateRange', {}) selectedDateRangeSync!: string;
}

